/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="company-detail-wrap form-page-wrap">
        <div class="bread-wrap">
            <div class="layout_n">
                <router-link to="/company">公司管理</router-link>  > <span> {{companyType==1 ? '已加入公司' : '待加入公司'}}</span>
            </div>
        </div>
        <div class="layout_n margin">
            <div class="message_content">
                <div class="process_wrap">
                    <div class="liner">
                        <div :class="{ 'line':true, 'line2': step2, 'line3': step3}"></div>
                    </div>
                    <!--步骤开始-->
                    <div class="step_wrap clearfix" >
                        <div :class="{ 'step': true, 'now': step1 , 'prev': step2||step3}">
                            <div class="step_line">
                                <div :class="{'first': step2||step3 , 'line': true}"></div>
                                <div class="radius_wrap">
                                    <div class="radius">1</div>
                                </div>
                            </div>
                            <div class="text">编辑公司信息</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step2 , 'prev': step3}">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">2</div>
                                </div>
                            </div>
                            <div class="text">信息审核中</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step3 }">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">3</div>
                                </div>
                            </div>
                            <div class="text">信息发布</div>
                        </div>
                    </div>
                </div>
                <div class="item-wrap">
                    <form @submit.prevent="goSubmit">
                        <!--基本信息-->
                        <div class="item">
                            <div class="title"><div class="sub-title">基本信息</div></div>
                            <div class="baseinfo-wrap">
                                <!--一系列表单-->
                                <ul class="clearfix base-ul">
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required" >公司全称</label>
                                            <input type="text" maxlength="40" :readonly="step2" name="companyFullName" v-model="baseInfo.companyFullName" v-validate="'required'" placeholder="填写公司全称,不超过40字">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('companyFullName')">{{errors.first('companyFullName')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">公司简称</label>
                                            <input type="text" maxlength="20"  :readonly="step2" name="companyName" v-model="baseInfo.companyName" v-validate="'required'"  placeholder="填写公司简称,不超过20字">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('companyName')">{{errors.first('companyName')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">公司英文名称</label>
                                            <input type="text" name="englishName"  :readonly="step2" v-model="baseInfo.englishName" v-validate="'englishName'" maxlength="100" placeholder="不超过100字">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('englishName')">{{errors.first('englishName')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">企业性质</label>
                                            <div class="select-ul-wrap">
                                                <vue-select :name="'companyNature'" :id="baseInfo.companyType" :readonly="step2" :selectKey="'title'" v-model="msg.companyType" @closed="closedCompanyType" @selected="getCompanyNature" :selectList="list.companyNatureList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&msg.companyTypeFlag">请选择企业性质</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">办公地址</label>
                                            <input type="text" name="companyAddress"  :readonly="step2" maxlength="50" v-model="baseInfo.companyAddress" v-validate="'required'" placeholder="填写办公地址，不超过50字">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('companyAddress')">{{errors.first('companyAddress')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">成立日期</label>
                                            <!-- <input type="text" name="establishDate" maxlength="50" v-model="baseInfo.establishDate" v-validate="'required'" placeholder=""> -->
                                            <div class="date-wrap" v-if="!step2">
                                                 <date-picker class="date-time" language="zh" @closed="closedEstablishDate" :format="'yyyy-MM-dd'" v-model="baseInfo.establishDate1" :input-class="'input'"></date-picker>
                                            </div>
                                            <input v-else :readonly="step2" v-model="msg.establishDate1" >
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&msg.establishDateFlag">请输入成立日期</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">登记日期</label>
                                            <!-- <input type="text" name="registrationDay" maxlength="50" v-model="baseInfo.registrationDay" v-validate="'required'" placeholder="填写登记日期"> -->
                                             <div class="date-wrap" v-if="!step2">
                                                 <date-picker @closed="closedRegistrationDay"  language="zh" class="date-time" :format="'yyyy-MM-dd'" v-model="baseInfo.registrationDay1" ></date-picker>
                                            </div>
                                            <input v-else :readonly="step2" v-model="msg.registrationDay1" >
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&msg.registrationDayFlag">请输入登记日期</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label :class=" {'label':true, ' required':requiredRules!=''}">登记编号</label>
                                            <input type="text"  name="privateRegisterNumber" @blur="asyncPrivateRegisterNumber" :readonly="step2"  maxlength="50" v-model="msg.privateRegisterNumber" v-validate="requiredRules+'privateRegNum'" placeholder="填写登记编号，如:X1234567">

                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('privateRegisterNumber')">{{errors.first('privateRegisterNumber')}}</span>
                                            <span v-show="!step2&& !errors.has('privateRegisterNumber') && msg.privateRegisterNumberFlag">该登记编号已有公司使用，请勿重复录入</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">公司状态</label>
                                            <!--<input type="text" placeholder="填写公司状态">-->
                                            <div class="select-ul-wrap">
                                                <vue-select :name="'privateCompanyStatus'" :id="baseInfo.privateCompanyStatus"  :readonly="step2" :selectKey="'title'" placeholder="填写公司状态" v-model="msg.privateCompanyStatus" @selected="getPrivateCompanyStatus" :selectList="list.privateCompanyStatusList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap two_input">
                                            <label class=" label required">管理规模</label>
                                            <div class="select-ul-wrap">
                                                <vue-select :name="'manageScaleStart'" :id="baseInfo.companyAssetSize" :readonly="step2" :selectKey="'title'" placeholder="" v-model="msg.companyAssetSize" @closed="closedCompanyAssetSize" @selected="getCompanyAssetSize" :selectList="list.manageScaleStartList"></vue-select>
                                            </div>
                                            <div class="select-ul-wrap">
                                                <vue-select :name="'manageScaleEnd'"  :id="baseInfo.assetCurrencyUnit"  :readonly="step2" :selectKey="'title'" placeholder="" v-model="msg.manageScaleEnd" @closed="closedManageScaleEnd" @selected="getManageScaleEnd" :selectList="list.manageScaleEndList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span class="errspan1" v-show="!step2&&msg.companyAssetSizeFlag">请选择管理规模</span>
                                            <span class="errspan2" v-show="!step2&&msg.assetCurrencyUnitFlag">请选择管理规模单位</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap ">
                                            <label class=" label">公司网址</label>
                                            <input type="text" maxlength="50" v-model="baseInfo.companyUrl" name="companyUrl" :readonly="step2" placeholder="填写公司网址">
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2&&errors.has('companyUrl')">{{errors.first('companyUrl')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap ">
                                            <label class=" label">注册地址</label>
                                            <input type="text" v-model="baseInfo.regAddr"  :readonly="step2" placeholder="">
                                        </div>
                                        <div class="err">
                                            <span></span>
                                        </div>
                                    </li>

                                    <li>
                                        <div class="input_wrap two_input">
                                            <label class=" label required">注册资本</label>
                                            <div class="select-ul-wrap">
                                                <input type="text" v-validate="'required|number'"  :readonly="step2" v-model="baseInfo.capital" name="privateBaseCurrencyUnit" placeholder="请输入注册资本" >
                                            </div>
                                            <div class="select-ul-wrap">
                                                <vue-select :name="'regCapitalEnd'" :id="baseInfo.privateBaseCurrencyUnit" :selectKey="'title'"  :readonly="step2" placeholder="" v-model="msg.privateBaseCurrencyUnit" @closed="closedPrivateBaseCurrencyUnit" @selected="getRegCapitalEnd" :selectList="list.manageScaleEndList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span class="errspan1"  v-show="!step2&&errors.has('privateBaseCurrencyUnit')">{{errors.first('privateBaseCurrencyUnit')}}</span>
                                            <span class="errspan2"  v-show="!step2&&msg.privateBaseCurrencyUnitFlag">请选择注册资本单位</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap two_input">
                                            <label class=" label required">实缴资本</label>
                                            <div class="select-ul-wrap">
                                                <input type="text" v-validate="'required|number'"  :readonly="step2"  v-model="baseInfo.contributedCapital" name="paidCapitalStart" placeholder="请输入实缴资本" >
                                            </div>
                                            <div class="select-ul-wrap">
                                                <vue-select :name="'paidCapitalEnd'" :id="baseInfo.contributedCapitalCurrencyUnit" :readonly="step2" :selectKey="'title'" placeholder="" v-model="msg.paidCapitalEnd" @closed="closedContributedCapitalCurrencyUnit" @selected="getPaidCapitalEnd" :selectList="list.manageScaleEndList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span class="errspan1" v-show="!step2&&errors.has('paidCapitalStart')">{{errors.first('paidCapitalStart')}}</span>
                                            <span class="errspan2" v-show="!step2&&msg.contributedCapitalCurrencyUnitFlag">请选择实缴资本单位</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">是否有海外基金</label>
                                            <div class="select-ul-wrap">
                                                <vue-select :readonly="step2" :id="baseInfo.privateOffshoreFund" @selected="getPrivateOffshoreFund" name="privateOffshoreFund" @closed="closedPrivateOffshoreFund"  :selectKey="'title'" v-model="msg.privateOffshoreFund" :selectList="list.privateOffshoreFundList" :placehoder="'请选择海外资金'"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.privateOffshoreFundFlag">请选择是否有海外基金</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">管理基金主要类别</label>
                                            <div class="select-ul-wrap">
                                                <vue-select :readonly="step2" :id="baseInfo.mainBusiness" @selected="getMainBusiness" name="mainBusiness" @closed="closedMainBusiness"  :selectKey="'title'" v-model="msg.mainBusiness" :selectList="list.mainBusinessList" :placehoder="'请选择基金主要类别'"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <span v-show="!step2 && msg.mainBusinessFlag">请选择管理基金主要类别</span>
                                        </div>
                                    </li>
                                </ul>
                                <!--个人照片-->
                                <div class="input-item company-logo">
                                    <div class="item-main clearfix">
                                        <label class="label">公司logo</label>
                                       <div class="logo_wrap">
                                           <div class="img_wrap">
                                               <img v-show="!baseInfo.companyLogo || baseInfo.companyLogo==null " src="../../assets/img/common/zwt.png">
                                               <img v-show="baseInfo.companyLogo && baseInfo.companyLogo!=null" :src="baseInfo.companyLogo" width="100" height="100">
                                           </div>
                                           <div class="up-load"  v-show="!step2">
                                               <div class="load-wrap">
                                                   <up-load :postURL="postURL"  :postType="postType" :method="'put'" @showSmallImg="getCompanyLogo" :errorMessage="'已上传公司logo'" :color="'$btn-408'" :labelText="'选择文件'"></up-load>
                                               </div>
                                               <span>支持480*480以下图片大小，格式支持jpeg、jpg、png</span>
                                           </div>
                                       </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--更多说明-->
                        <div class="item">
                            <div class="title"><div class="sub-title">更多说明</div></div>
                            <div class="baseinfo-wrap">
                                <!--公司简介-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label required">公司简介</label>
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="500" ref="companyIntro" @errorsChanged="companyIntroError" :readonly="step2"  :name="'companyIntro'" :validate="'required'" v-model="baseInfo.companyIntro" :placeholder="'(必填)，简单介绍公司背景'"></vue-textarea>
                                        </div>
                                    </div>
                                    <div class="err">
                                        <span v-show="!step2&&errors.has('companyIntro')">{{errors.first('companyIntro')}}</span>
                                    </div>
                                </div>
                                <!--投资理念-->
                                <div class="input-item">
                                    <div class="item-main">
                                        <label class="label required">投资理念</label>
                                        <div class="textarea-wrapper">
                                            <vue-textarea :num="500" ref="privateInvestIdea" @errorsChanged="privateInvestIdeaError"  :readonly="step2" :validate="'required'"  :name="'privateInvestIdea'" v-model="baseInfo.privateInvestIdea" :placeholder="'(必填)，简单介绍公司投资理念'"></vue-textarea>
                                        </div>
                                    </div>
                                    <div class="err">
                                        <span v-show="!step2&&errors.has('privateInvestIdea')">{{errors.first('privateInvestIdea')}}</span>
                                    </div>
                                </div>
                              <!--投资团队-->  
                              <div class="input-item">
                                  <div class="item-main">
                                    <label class="label required">投资团队</label>
                                    <div class="textarea-wrapper">
                                      <vue-textarea :num="500" ref="privateInvestTeam" @errorsChanged="privateInvestTeamError"  :readonly="step2" :validate="'required'"  :name="'privateInvestTeam'" v-model="baseInfo.privateInvestTeam" :placeholder="'(必填)，简单介绍公司投资团队'"></vue-textarea>
                                    </div>
                                  </div>
                                  <div class="err">
                                    <span v-show="!step2&&errors.has('privateInvestTeam')">{{errors.first('privateInvestTeam')}}</span>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <!--提交按钮-->
                        <div class="btn-commit-wrap"  v-show="!step2">
                            <button class="btn-bg-def commit btn" type="submit">提交</button>
                            <button class="btn-def save  btn" @click="goToSave">保存暂不提交</button>
                        </div>
                        <p class="ps-hot">温馨提示：审核期间不可编辑基金信息</p>
                    </form>
                </div>
            </div>
        </div>
        <submit-ok :isSave="isSave" @closeModal="golist"></submit-ok>
    </div>
</template>
<script>
    import upLoad from '../../components/common/upload';
//    import datePicker from 'vuejs-datepicker';
    import datePicker from '../../components/middleware/Datepicker';
    import vueSelect from '../../components/form/select';
    import vueTextarea from '../../components/form/textarea.vue';
    import formList from '../../assets/js/formList';
    import tool from '../../assets/js/common/tool'
    import submitOk from '../../components/modal/submitOk'
    export default {
        components:{
            upLoad,
            datePicker,
            vueTextarea,
            vueSelect,
            submitOk
        },
        data (){
            return {
                isSave: false,
                postURL: '/fileupload/uploadimg',
                postType: 'Company_logo',
                step1: false,
                step2: true,
                step3: false,
                companyId: 1,
                companyType: 1,
                list: formList,
                requiredRules: 'required|',
                baseInfo:{
                    companyFullName: null,
                    companyType: formList.companyNatureList[0].id,  /*企业性质*/
                    companyAssetSize: formList.manageScaleStartList[0].id,/*公司规模*/
                    manageScaleEnd: formList.manageScaleEndList[0].id, /*公司规模单位*/
                    privateBaseCurrencyUnit: formList.manageScaleEndList[0].id,   /*注册资本*/
                    paidCapitalEnd:  formList.manageScaleEndList[0].id,/*实缴资本*/
                    companyName: null,
                    englishName: null,
                    companyAddress: null,
                    establishDate: null,
                    registrationDay: null,
                    privateRegisterNumber: null,
                    regAddr: null,
                    capital: null,
                    contributedCapital: null,
                    mainBusiness: formList.mainBusinessList[0].id,/*管理基金主要类别*/
                    privateOffshoreFund: formList.privateOffshoreFundList[0].id,
                    privateInvestTeam: null,
                },
                msg:{
                    establishDate1: null,
                    privateBaseCurrencyUnit:formList.manageScaleEndList[0].title,   /*注册资本*/
                    paidCapitalEnd:  formList.manageScaleEndList[0].title,/*实缴资本*/
                    registrationDayFlag: false,
                    establishDateFlag: false,
                    privateCompanyStatus:  formList.privateCompanyStatusList[0].title,  /*公司状态*/
                    companyType: formList.companyNatureList[0].title, //公司性质
                    companyAssetSize: formList.manageScaleStartList[0].title, //公司规模
                    manageScaleEnd: formList.manageScaleEndList[0].title, //公司规模
                    registrationDay1: null,
                    privateRegisterNumber: '',  //登记编号
                    privateRegisterNumberFlag: false , //登记编号
                    mainBusiness: formList.mainBusinessList[0].title,/*管理基金主要类别*/
                    privateOffshoreFund: formList.privateOffshoreFundList[0].title,
                    companyIntroFlag: false,
                    privateInvestIdeaFlag: false,
                    companyTypeFlag: false,/*企业性质*/
                    companyAssetSizeFlag: false , /*管理规模*/
                    assetCurrencyUnitFlag: false, /*管理规模单位*/
                    privateBaseCurrencyUnitFlag: false , /*注册资本单位*/
                    contributedCapitalCurrencyUnitFlag:false, /*实缴资本单位*/
                    privateOffshoreFundFlag: false , /*海外基金*/
                    mainBusinessFlag: false, /*管理主要类别*/
                }
            }
        },
        computed: {
            getestablishDate(){
                return `${this.baseInfo.establishDate1}`
            },
            allTextFlag(){
                return this.msg.companyIntroFlag &&  this.msg.privateInvestIdeaFlag
            },
            allSeleFlag(){
                return !this.msg.companyTypeFlag && !this.msg.mainBusinessFlag
                    &&  !this.msg.companyAssetSizeFlag && !this.msg.assetCurrencyUnitFlag
                    && !this.msg.privateBaseCurrencyUnitFlag && !this.msg.contributedCapitalCurrencyUnitFlag
                    && !this.msg.privateOffshoreFundFlag && !this.msg.registrationDayFlag
                    && !this.msg.establishDateFlag && !this.msg.privateRegisterNumberFlag
            }

        },
        created(){
            this.$store.commit('getLoginInfo',  this.getCompanyDetail);
//            this.getCompanyDetail();
        },
        mounted(){

        },
        watch: {
          $route(){
            this.getCompanyDetail();
          }
        },

        methods:{
            /*单独验证*/
            companyIntroError(flag){
                this.msg.companyIntroFlag = flag;
            },
            privateInvestIdeaError(flag){
                this.msg.privateInvestIdeaFlag = flag;
            },
            /*获取详情*/
            getCompanyDetail(){
                this.companyId = this.$route.params.id;
                this.companyType = this.$route.params.type; // 1 已加入  2  待加入
                if(this.companyId == 0){ //编辑  第一步
                    this.setStep(1);
                } else {
                    if(this.companyType == 1){
                        this.setStep(3);
                    } else if(this.companyType == 2){
                        this.setStep(1);
                    }
                    let url = this.companyType ==1 ? `/company/result/fundDcId_${this.companyId}/detail`: `/company/report/id_${this.companyId}/detail`;
                    this.$http.request({
                        url: url
                    }, response => {
                        if(response.data.code === 200){
                            this.baseInfo = response.data.data;
                            this.setTimeData();
                             if( this.companyType == 2 && this.baseInfo.auditStatus ==0){ // 待审核
                                this.setStep(2);
                            }
                        }
                    },err => {
                        this.noDataShow = true;
                    })
                }
            },
            /*初始化一些数据*/
            setTimeData(){
                this.changeRules();
                this.baseInfo.establishDate1 = tool.numToDate(this.baseInfo.establishDate);
                this.baseInfo.registrationDay1 = tool.numToDate(this.baseInfo.registrationDay);
                this.msg.establishDate1 = tool.transformTime(this.baseInfo.establishDate ,'yyyy-mm-dd');
                this.msg.registrationDay1 = tool.transformTime(this.baseInfo.registrationDay ,'yyyy-mm-dd');
                this.msg.privateRegisterNumber = this.baseInfo.privateRegisterNumber;
            },
            /*修改 登记编码规则*/
            changeRules(){
                //原需求：所有企业性质（即公司类型字段）的登记编号（即备案编码）都必填
                // 现需求：仅要求企业性质选择私募投资管理公司时，登记编号必填，其余企业性质的登记编号非必填。
                if(this.baseInfo.companyType == 1){
                    this.requiredRules = 'required|';
                } else {
                    this.requiredRules = '';
                }
            },
            beforeCommit(){
                if(this.step3){
                    this.$delete(this.baseInfo, 'id');
                }
                this.baseInfo.establishDate = tool.dateToNum(this.baseInfo.establishDate1);
                this.baseInfo.registrationDay = tool.dateToNum(this.baseInfo.registrationDay1);
                this.baseInfo.privateRegisterNumber = this.msg.privateRegisterNumber;
            },
            golist(){
                this.$router.push({path: '/company', query:{item: 2}});
            },

            /*获取公司logo*/
            getCompanyLogo(url){
                this.baseInfo.companyLogo = url;
            },
            /*设置步骤进度*/
            setStep(step){
                this.step1 = false;
                this.step2 = false;
                this.step3 = false;
                this['step'+step] = true;
            },
            /*动态验证备案号码*/
            asyncPrivateRegisterNumber(){
                this.msg.privateRegisterNumberFlag = false;
                if(this.msg.privateRegisterNumber != this.baseInfo.privateRegisterNumber && !this.errors.has('privateRegisterNumber') &&!!this.msg.privateRegisterNumber){
                    this.$http.request({
                        url: `/company/checkRegisterNumber?registerNumber=${this.msg.privateRegisterNumber}`
                    }, res => {
                        if(res.data.code === 200 ){
                            this.msg.privateRegisterNumberFlag = !res.data.data;
                        } else {
                            this.msg.privateRegisterNumberFlag = true;
                        }
                    }, err => {
                        this.msg.privateRegisterNumberFlag = true;
                    });
                }
            },
            /*关闭登记日期*/
            closedRegistrationDay(){
                if(this.baseInfo.registrationDay1){
                    this.msg.registrationDayFlag = false;
                }else {
                    this.msg.registrationDayFlag = true;
                }
            },
            /*关闭成立时间*/
            closedEstablishDate(){
                if(this.baseInfo.establishDate1){
                    this.msg.establishDateFlag = false;
                }else {
                    this.msg.establishDateFlag = true;
                }
            },
            /*对时间做标示*/
            getFlag(){
                this.closedEstablishDate();
                this.closedRegistrationDay();
                this.closedPrivateOffshoreFund();/*海外资金*/
                this.closedMainBusiness();/*管理基金主要类别*/
                this.closedCompanyType();/*企业性质*/
                this.closedCompanyAssetSize();  /*管理规模*/
                this.closedManageScaleEnd(); /*管理规模 单位*/
                this.closedPrivateBaseCurrencyUnit(); /*注册资本单位*/
                this.closedContributedCapitalCurrencyUnit(); /*实缴资本单位*/
            },
            // 选择海外资金
            getPrivateOffshoreFund(obj){
                this.baseInfo.privateOffshoreFund = obj.id;
            },
            closedPrivateOffshoreFund(){
                if(this.baseInfo.privateOffshoreFund == null || this.baseInfo.privateOffshoreFund == undefined){
                    this.msg.privateOffshoreFundFlag = true;
                } else {
                    this.msg.privateOffshoreFundFlag = false;
                }
            },
            //管理基金主要类别
            getMainBusiness(obj){
                this.baseInfo.mainBusiness = obj.id;
            },
            closedMainBusiness(){
                if(this.baseInfo.mainBusiness == null || this.baseInfo.mainBusiness == undefined){
                    this.msg.mainBusinessFlag = true;
                } else {
                    this.msg.mainBusinessFlag = false;
                }
            },
            /*公司状态*/
            getPrivateCompanyStatus(obj){
                this.baseInfo.privateCompanyStatus = obj.id;
            },
            /*公司性质*/
            getCompanyNature(obj){
                this.baseInfo.companyType = obj.id;
                this.changeRules();
            },
            closedCompanyType(){ /*企业性质*/
                if(this.baseInfo.companyType == null || this.baseInfo.companyType == undefined){
                    this.msg.companyTypeFlag = true;
                } else {
                    this.msg.companyTypeFlag = false;
                }
            },
            /*管理规模*/
            getCompanyAssetSize(obj){
                this.baseInfo.companyAssetSize = obj.id;
            },
            closedCompanyAssetSize(){
                if(this.baseInfo.companyAssetSize == null || this.baseInfo.companyAssetSize == undefined){
                    this.msg.companyAssetSizeFlag = true;
                } else {
                    this.msg.companyAssetSizeFlag = false;
                }
            },
            /*管理规模 单位*/
            getManageScaleEnd(obj){
                this.baseInfo.assetCurrencyUnit = obj.id;
            },
            closedManageScaleEnd(){
                if(this.baseInfo.assetCurrencyUnit == null || this.baseInfo.assetCurrencyUnit == undefined){
                    this.msg.assetCurrencyUnitFlag = true;
                } else {
                    this.msg.assetCurrencyUnitFlag = false;
                }
            },
            /*注册资本单位*/
            getRegCapitalEnd(obj){
                this.baseInfo.privateBaseCurrencyUnit = obj.id;
            },
            closedPrivateBaseCurrencyUnit(){
                if(this.baseInfo.privateBaseCurrencyUnit == null || this.baseInfo.privateBaseCurrencyUnit == undefined){
                    this.msg.privateBaseCurrencyUnitFlag = true;
                } else {
                    this.msg.privateBaseCurrencyUnitFlag = false;
                }
            },
            /*实缴资本单位*/
            getPaidCapitalEnd(obj){
                this.baseInfo.contributedCapitalCurrencyUnit = obj.id;
            },
            closedContributedCapitalCurrencyUnit(){
                if(this.baseInfo.contributedCapitalCurrencyUnit == null || this.baseInfo.contributedCapitalCurrencyUnit == undefined){
                    this.msg.contributedCapitalCurrencyUnitFlag = true;
                } else {
                    this.msg.contributedCapitalCurrencyUnitFlag = false;
                }
            },
            showModal(){
                this.$modal.show('submitOk');
            },
            goSubmit(){
                this.$refs.privateInvestIdea.validateChild();
                this.$refs.companyIntro.validateChild();
                this.getFlag();

                this.$validator.validateAll().then(result => {
                    if (result && this.allTextFlag && this.allSeleFlag ) {
                        this.beforeCommit();
                        this.$http.request({
                            url: `/company/saveOrUpdateThenAudit`,
                            method: 'post',
                            data: this.baseInfo
                        }, res => {
                            if(res.data.code == 200){
                                this.isSave = false;
                                this.showModal();
                            }
                        }, err => {

                        });
                    }

                });

            },
            /*保存不提交*/
            goToSave(e){
                e.preventDefault();
                if(!this.errors.has('privateRegisterNumber') && !this.msg.privateRegisterNumberFlag){
                    this.beforeCommit();
                    this.$http.request({
                        url: `/company/saveOrUpdate`,
                        method: 'post',
                        data: this.baseInfo
                    }, res => {
                        if(res.data.code == 200){
                            this.isSave = true;
                            this.showModal();
                        }
                    }, err => {

                    });
                } else {
                    this.$store.commit('msg', '登记编号重复');
                }
            }
        }
    }
</script>
<style lang="scss" type="text/scss">
@import "../../assets/css/common/form";
.company-detail-wrap{
    ul.base-ul{
        li:nth-child(3n-1){
            /*.label{*/
                /*width:140px;*/
            /*}*/
            /*.err{*/
                /*left:140px;*/
            /*}*/
        }

    }
    .load-wrap{
        display: inline-block;
        margin-right:10px;
        .label-for-file{
            font-size:16px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/company/detail.vue